import request from "root/js/request";

export const getWBDynamicProductsByIdKeywords = async ({
  productId,
  keyword_ids,
  date_from,
  date_to,
  limit,
  offset,
  ordering,
  ...rest
}) => {
  const response = await request({
    url: `/wb_dynamic/products/${productId}/keywords/`,
    method: "post",
    data: {
      productId,
      keyword_ids,
      date_from,
      date_to,
      limit,
      offset,
      ordering,
      ...rest,
    },
  });
  return response.data;
};
